module.exports = __webpack_public_path__ + "static/media/star-yellow.d2498a7e.svg";